function inferUserAccessFromAST(ast) {
  return ast.reduce((acc, node) => {
    var _a;
    if (!acc) {
      return false;
    }
    if ((_a = node.pm2) == null ? void 0 : _a.isScrambled) {
      return false;
    }
    if (node.children) {
      return inferUserAccessFromAST(node.children);
    }
    return true;
  }, true);
}

export { inferUserAccessFromAST };
//# sourceMappingURL=util.infer-access-from-ast.js.map
